import {useState,useEffect, useContext} from 'react'
import Container from '../../Components/Notifications/Container'
import ValidateUser from '../../Components/UserCredentials/ValidateUser';
import {Helmet} from "react-helmet";
import { GeneralFunctionsContext } from '../../Components/Contexts/GeneralFunctionsContext';
const url = '/geniuxmusic/api/fetch_songs.php'

export default function MaxPlayer ({props}) {
     const {innerWidth, offset} = useContext(GeneralFunctionsContext);
    
    return (
        <>
        <ValidateUser/>
        <Helmet>
            <title>Notifications</title>
            <meta property="og:title" content="Notifications"/>
            <meta name="title" content="Notifications"/>
            <meta name="description" content="Stay up-to-date with geniux music."/>
            <meta property="og:image" content="/assets/images/geniux_music_logo.png"/>
        </Helmet>
         <Container innerWidth={innerWidth}/> 
      
        </>
    )
}



